/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});function n(o){const t={horizontal:"left",vertical:"bottom"};return o&&(t.horizontal="right"),t}function i(o){const t={horizontal:"left",vertical:"top"};return o&&(t.horizontal="right"),t}exports.getAnchorAlign=n;exports.getPopupAlign=i;
